// removed by extract-text-webpack-plugin
module.exports = {"label-text":"ReporteInventario__label-text___2bV_q","btn-reporte":"ReporteInventario__btn-reporte___3q_4n","btn-cancel":"ReporteInventario__btn-cancel___10Bp_","div-detalle":"ReporteInventario__div-detalle___1UeAA","center-btn":"ReporteInventario__center-btn___39xPm","form-group-padding":"ReporteInventario__form-group-padding___Gm0OX"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/api/reportes/ReporteInventario.css
// module id = 1155
// module chunks = 0